const defaultState = {
    notifications: [],
	unreadCount: null,
}

const SET_NOTIFICATIONS = "SET_NOTIFICATIONS"
const SET_COUNT = "SET_COUNT"

export const notificationsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_NOTIFICATIONS:
            return {...state, notifications: action.payload}
		case SET_COUNT:
			return {...state, unreadCount: action.payload}

        default:
            return state
    }
}

export const setNotitficationsAction = (payload) => ({type: SET_NOTIFICATIONS, payload})
export const setCountAction = (payload) => ({type: SET_COUNT, payload})
